import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-500">
          <i className="ri-compass-3-line" />
        </span>
        <p className="mt-6 font-heading text-6xl font-black tracking-tight text-primary-500 md:text-7xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这个页面还没有内容
        </h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的地址 <span className="font-mono text-foreground-800">{location.pathname}</span> 暂时不存在，
          不如回到首页逛逛，或从下面的分类里挑一个感兴趣的内容。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-600 whitespace-nowrap"
          >
            全站搜索
          </Link>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-500">
                <i className={cat.icon} />
              </span>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}